"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const dynamic_1 = __importDefault(require("next/dynamic"));
const BurgerMenu = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./layouts/burger'))));
const IconsMenu = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./layouts/icons'))));
const DefaultMenu = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./layouts/default'))));
const CPMenu = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./layouts/cp'))));
/*
const IconLabelMenu = dynamic(() => import('./layouts/icon-label'));
const Default = dynamic(() => import('./layouts/default'));
*/
const MENU_LAYOUTS = {
    BURGER: 'burguer',
    ICONS: 'icons',
    DEFAULT: 'default',
    CP: 'cp',
};
const Menu = (props) => {
    const { layout } = props;
    switch (layout) {
        case MENU_LAYOUTS.CP:
            return react_1.default.createElement(CPMenu, Object.assign({}, props));
        case MENU_LAYOUTS.BURGER:
            return react_1.default.createElement(BurgerMenu, Object.assign({}, props));
        case MENU_LAYOUTS.DEFAULT:
            return react_1.default.createElement(DefaultMenu, Object.assign({}, props));
        case MENU_LAYOUTS.ICONS:
            return react_1.default.createElement(IconsMenu, Object.assign({}, props));
        default:
            return null;
    }
};
exports.default = Menu;
//# sourceMappingURL=index.js.map